import GrayCard from "components/gray-card";
import DragNDrop from "components/inputs/dragNdrop";
import Dropdown from "components/inputs/dropdown";
import TextInput from "components/inputs/text-input";
import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { IReleaseInfo } from "../..";

interface IProps {
  data: IReleaseInfo;
  onChangeData: (text: any, key: string) => void;
}
const ReleaseInformation = ({ data, onChangeData }: IProps) => {
  return (
    <GrayCard title="Release Information">
      <Typography weight="semibold" mb="0.8" color={Colors.grey400}>
        Cover Art
      </Typography>
      <ImageArea>
        {data.coverImg ? (
          <>
            <CloseButton onClick={() => onChangeData(undefined, "coverImg")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle cx="12.0003" cy="12" r="5.14286" fill="#1E1E1E" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.002 11.9998C22.002 17.5226 17.5248 21.9998 12.002 21.9998C6.4791 21.9998 2.00195 17.5226 2.00195 11.9998C2.00195 6.47691 6.4791 1.99976 12.002 1.99976C17.5248 1.99976 22.002 6.47691 22.002 11.9998ZM8.97158 8.96941C9.26447 8.67652 9.73934 8.67652 10.0323 8.96941L12.002 10.9391L13.9716 8.96943C14.2645 8.67654 14.7394 8.67654 15.0323 8.96943C15.3252 9.26232 15.3252 9.7372 15.0323 10.0301L13.0626 11.9998L15.0323 13.9694C15.3252 14.2623 15.3252 14.7372 15.0323 15.0301C14.7394 15.323 14.2645 15.323 13.9716 15.0301L12.002 13.0605L10.0323 15.0301C9.73937 15.323 9.26449 15.323 8.9716 15.0301C8.67871 14.7372 8.67871 14.2623 8.9716 13.9695L10.9413 11.9998L8.97158 10.0301C8.67868 9.73717 8.67868 9.2623 8.97158 8.96941Z"
                  fill="#CDCDCD"
                />
              </svg>
            </CloseButton>{" "}
            <ImageContainer
              src={URL.createObjectURL(data.coverImg)}
              alt="cover-img"
            />
          </>
        ) : (
          <DragNDrop
            setFile={(file) => onChangeData(file, "coverImg")}
            limit={10}
          />
        )}
      </ImageArea>
      <Gap />
      <TextInput
        placeholder="Enter your Single, Album or EP name"
        label="Release Title"
        value={data.title}
        onChange={(e) => {
          onChangeData(e.target.value, "title");
        }}
      />
      <Gap />
      <Dropdown
        placeholder="Enter your Single, Album or EP name"
        label="Type of Release"
        items={["Single", "EP", "Album", "Mixtape", "Live", "Remix"]}
        chosenItem={data.type}
        selectItem={(value) => {
          onChangeData(value, "type");
        }}
      />
      <Gap />
      <TextInput
        placeholder="Enter Artist name"
        label="Artist"
        value={data.artist}
        onChange={(e) => {
          onChangeData(e.target.value, "artist");
        }}
      />
    </GrayCard>
  );
};

export default ReleaseInformation;

const ImageArea = styled.div`
  width: 24.6rem;
  height: 24.6rem;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: 30rem;
  }
`;
const ImageContainer = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const CloseButton = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  cursor: pointer;
  position: absolute;
  top: -1.2rem;
  right: -1.2rem;
  z-index: 2;
  @media only screen and (max-width: 769px) {
    top: 0rem;
    right: 0rem;
  }
`;
const Gap = styled.div`
  height: 1.6rem;
`;
